export default __webpack_public_path__ + "static/media/hht2_ep17_book_wp_01.0b4b6247.jpg";